<ngx-spinner></ngx-spinner>

<div class="offline_banner" *ngIf="isOffline" role="alert">
  <div class="offline_banner_content">
    <i class="ri-wifi-off-line"></i>
    <span>{{ offlineMessage }}</span>
  </div>
</div>

<section *ngIf="isLoggedIn()">
  <app-top-nav-bar></app-top-nav-bar>
  <div class="d-flex align-items-center">
    <app-menu ></app-menu>
    <section class="content-section"  id="section1">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </section>
  </div>
</section>

<router-outlet *ngIf="!isLoggedIn()"></router-outlet>


<div class="error_toaster">
  <!-- <img src="./assets/image/close-circle-fill.svg"> -->
  <h5 id="errorMsg"></h5>
  <button mat-icon-button class="btn_icon" (click)="close()">
    <i class="ri-close-circle-line"></i>
  </button>
</div>

<div class="warning_toaster">
  <!-- <img src="./assets/image/error-warning-fill.svg"> -->
  <h5 id="warningMsg"></h5>
  <button mat-icon-button class="btn_icon" (click)="close()">
    <i class="ri-close-circle-line"></i>
  </button>
</div>

<div class="success_toaster">
  <!-- <img src="./assets/image/checkbox-circle-fill.svg"> -->
  <h5 id="successMsg"></h5>
  <button mat-icon-button class="btn_icon" (click)="close()">
    <i class="ri-close-circle-line"></i>
  </button>
</div>

<div class="bg_loader" id="loader">
  <div class="box loader-1">
    <div class="loader">
      <div class="loader-ball-1"></div>
      <div class="loader-ball-2"></div>
    </div>
    <p>Loading</p>
  </div>
</div>